import React from 'react'

const ProfileRejectedTemplate = ({ data }) => {
  const {
    studentName = 'Student',
    rejectedDetails = [],
    signatureName = 'Placement Team',
    signatureRole = '',
    signatureInstitute = '',
    signatureContact = ''
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      
      <p style={{ paddingTop: '8px' }}>Dear {studentName},</p>
      
      <p style={{ paddingTop: '8px' }}>
        Your recent request to update your profile has been reviewed by the Training & Placement Office (TPO).
      </p>

      <p style={{ paddingTop: '8px' }}>
        After careful verification, the requested update cannot be approved at this time due to inconsistencies / insufficient validation in the submitted details.
      </p>

      <p style={{ paddingTop: '12px', fontWeight: 'bold', marginBottom: '8px' }}>Rejected Details</p>
      
      <table style={{ borderCollapse: 'collapse', width: '100%', maxWidth: '600px' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #333', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Section</th>
            <th style={{ border: '1px solid #333', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Fields</th>
            <th style={{ border: '1px solid #333', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Rejected Reason (If Provided)</th>
          </tr>
        </thead>
        <tbody>
          {rejectedDetails.map((item, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid #333', padding: '8px' }}>{item.section}</td>
              <td style={{ border: '1px solid #333', padding: '8px' }}>{item.fields}</td>
              <td style={{ border: '1px solid #333', padding: '8px' }}>{item.reason || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p style={{ paddingTop: '12px', fontWeight: 'bold', marginBottom: '4px' }}>Next Steps:</p>
      <p style={{ margin: '4px 0' }}>Please review the information entered and ensure it is accurate and verifiable.</p>
      <p style={{ margin: '4px 0' }}>Upload relevant supporting documents, if applicable.</p>
      <p style={{ margin: '4px 0' }}>Re-submit the request only after making the necessary corrections.</p>

      <p style={{ paddingTop: '12px' }}>
        For any clarification, you may contact the Placement Office during working hours.
      </p>

      <p style={{ paddingTop: '10px', paddingBottom: '2px', margin: '0px' }}>Regards,</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureName}</p>
      {signatureRole && <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureRole}</p>}
      {signatureInstitute && <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureInstitute}</p>}
      {signatureContact && <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureContact}</p>}
    </div>
  )
}

export default ProfileRejectedTemplate
